import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export function createPackageJSON() {
  var dependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var entry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/index.js";
  return JSON.stringify({
    name: "sandpack-project",
    main: entry,
    dependencies: dependencies
  }, null, 2);
}
export function addPackageJSONIfNeeded(files, dependencies, entry) {
  var newFiles = _objectSpread({}, files);

  if (!newFiles["/package.json"]) {
    if (!dependencies) {
      throw new Error("No dependencies specified, please specify either a package.json or dependencies.");
    }

    if (!entry) {
      throw new Error("Missing 'entry' parameter. Either specify an entry point, or pass in a package.json with the 'main' field set.");
    }

    newFiles["/package.json"] = {
      code: createPackageJSON(dependencies, entry)
    };
  }

  return newFiles;
}
export function extractErrorDetails(msg) {
  if (msg.title === "SyntaxError") {
    var title = msg.title,
        path = msg.path,
        message = msg.message,
        line = msg.line,
        column = msg.column;
    return {
      title: title,
      path: path,
      message: message,
      line: line,
      column: column
    };
  }

  var relevantStackFrame = getRelevantStackFrame(msg.payload.frames);

  if (!relevantStackFrame) {
    return {
      message: msg.message
    };
  }

  var errorInCode = getErrorInOriginalCode(relevantStackFrame);
  var errorLocation = getErrorLocation(relevantStackFrame);
  var errorMessage = formatErrorMessage(relevantStackFrame._originalFileName, msg.message, errorLocation, errorInCode);
  return {
    message: errorMessage,
    title: msg.title,
    path: relevantStackFrame._originalFileName,
    line: relevantStackFrame._originalLineNumber,
    column: relevantStackFrame._originalColumnNumber
  };
}

function getRelevantStackFrame(frames) {
  if (!frames) {
    return;
  }

  return frames.find(function (frame) {
    return !!frame._originalFileName;
  });
}

function getErrorLocation(errorFrame) {
  return errorFrame ? " (".concat(errorFrame._originalLineNumber, ":").concat(errorFrame._originalColumnNumber, ")") : "";
}

function getErrorInOriginalCode(errorFrame) {
  var lastScriptLine = errorFrame._originalScriptCode[errorFrame._originalScriptCode.length - 1];
  var numberOfLineNumberCharacters = lastScriptLine.lineNumber.toString().length;
  var leadingCharacterOffset = 2;
  var barSeparatorCharacterOffset = 3;
  var extraLineLeadingSpaces = leadingCharacterOffset + numberOfLineNumberCharacters + barSeparatorCharacterOffset + errorFrame._originalColumnNumber;
  return errorFrame._originalScriptCode.reduce(function (result, scriptLine) {
    var leadingChar = scriptLine.highlight ? ">" : " ";
    var lineNumber = scriptLine.lineNumber.toString().length === numberOfLineNumberCharacters ? "".concat(scriptLine.lineNumber) : " ".concat(scriptLine.lineNumber);
    var extraLine = scriptLine.highlight ? "\n" + " ".repeat(extraLineLeadingSpaces) + "^" : "";
    return result + // accumulator
    "\n" + leadingChar + // > or " "
    " " + lineNumber + // line number on equal number of characters
    " | " + scriptLine.content + // code
    extraLine // line under the highlighed line to show the column index
    ;
  }, "");
}

function formatErrorMessage(filePath, message, location, errorInCode) {
  return "".concat(filePath, ": ").concat(message).concat(location, "\n").concat(errorInCode);
}